export default function postGenerateLetsEncryptReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'POST_GENERATE_LETS_ENCRYPT_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'POST_GENERATE_LETS_ENCRYPT_ERROR':
      return {...state, ...{error: action.error}};

    case 'POST_GENERATE_LETS_ENCRYPT_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}